  <div *ngIf="isCheckBoxModalOpen" [config]="{ show: isCheckBoxModalOpen, backdrop: 'static' }"
    (onHidden)="onCheckBoxModalHidden()" bsModal #autoShownModal="bs-modal" class="modal fade" tabindex="-1" role="dialog"
    aria-hidden="true">
    <div class="custom-theme-modal modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content bg-white">
        <div class="modal-header d-block pt-4 pb-2">
          <div class="row border-bottom pb-2 ">
            <div *ngIf="!mobileBackButtonFlag" class="col-8 pr-0">
              <span class="heading-4 d-inline-block">     
                <img src="assets/images/icons/back.svg" alt="Back" class="pr-2 cursor-pointer" (click)="backClicked()">
                <span *ngIf="clicked === numbers.ONE">  
                  {{mls.languageText.community.key167}}
                </span> 
                <span *ngIf="clicked === numbers.ZERO">  
                   {{mls.languageText.community.key171}}
                </span>
                <span *ngIf="clicked === numbers.TWO">  
                  {{mls.languageText.community.key166}}
              </span>
                <span *ngIf="clicked === numbers.THREE && reviewState === numbers.ONE">  
                  {{mls.languageText.community.key163}} ({{selectedLength}} {{mls.languageText.community.key18}})
               </span>
               <span *ngIf="clicked === numbers.THREE && reviewState === numbers.TWO">  
                {{mls.languageText.community.key164}} ({{selectedLength}} {{mls.languageText.community.key18}})
            </span>
              </span>              
            </div>
            <div class="col-4 col-md-4 text-right ">
              <span *ngIf="clicked === numbers.ONE" class="position-relative ml-3 float-right cursor-pointer color-blue" (click)="removeMemberClicked()">
                {{mls.languageText.community.key166}}
              </span>
            </div>
          </div>
        
            <app-community-member-listing
              [filterPlaceholder]="membersFilterPlaceholder" 
              [noDataFoundLabel]="membersNoDataFoundLabel"
              [selectedTitle]="membersSelectedTitle" 
              [selectedLimit]="membersSelectedLimit" [title]="membersTitle"
              [maxLimitErrorLabel]="membersMaxLimitErrorLabel"
              [apiInProcess]="createCommunityService.membersApiInProcess"
              [suggestionList]="createCommunityService.membersSuggestionList" 
              [selectedList]="selectedMembers"
              [memberList]="createCommunityService.memberList"
              [isViewAllEnable]="membersIsViewAllEnable"
              [loggedInUserCustomId]="createCommunityService.loggedInUser.custom_id"
              (emitSearchKey)="searchInConnectionList($event)" 
              (emitBackToSuggestions)="backToMembersSuggestion()"
              (emitViewAll)="viewAllMembers($event)" 
              (emitOnScroll)="onMembersScroll()"
              (emitOnMemberScroll)="onCommunityMemberScroll()" 
              (emitMembersSelected) ="membersSelected($event)"
              (emitMembersRemoved) ="membersRemoved($event)"
              [communityCreatedBy]="communityData"
              (emitSelectedList)="selectedMemberLength($event)"
              [showExistingUserFlag]="showMobileBackButtonFlag"
              (emitCheckUncheckUser)="checkUncheckMember($event)"
              [membersSelectedRemoved]="this.membersSelectedRemoved"
              [clicked]="clicked"
              [reviewState]="reviewState"
              [callingFrom]="callingFrom"
              [communityId]="communityId"
              [communityEntityCode]="communityDetail?.da_id"
              >
            </app-community-member-listing> 
        </div>
        <div class="pb-4 pt-2 px-4">
          <button *ngIf="clicked === numbers.ZERO" [ngClass]="[fcs.device_detail.is_mobile ? 'small' : 'medium',!selectedLength ? 'filled-disabled':'filled']" [disabled]="!selectedLength" class="btn-design position-relative ml-3  float-right" (click)="confirmListClicked();changeReviewState()" >
          {{mls.languageText.community.key159}}
        </button>
        <button *ngIf="clicked === numbers.THREE && reviewState === numbers.ONE" [disabled]="createCommunityService.membersApiInProcess" [ngClass]="fcs.device_detail.is_mobile ? 'small' : 'medium'" class="btn-design filled position-relative ml-3 float-right" (click)="setMembers(true);selectionComplete()" >
          {{mls.languageText.community.key162}}
        </button>
     
        <button *ngIf="clicked === numbers.ONE" [ngClass]="fcs.device_detail.is_mobile ? 'small' : 'medium'" class="btn-design filled position-relative ml-3 float-right" (click)="addMemberClicked()" >
        {{mls.languageText.community.key171}} 
      </button>
      <button *ngIf="clicked === numbers.TWO" [disabled]="!selectedLength" [ngClass]="[fcs.device_detail.is_mobile ? 'small' : 'medium',!selectedLength ? 'filled-disabled':'filled']" class="btn-design position-relative ml-3 float-right" (click)="confirmListClicked()" >
        {{mls.languageText.community.key160}}
      </button>
      <button *ngIf="clicked === numbers.THREE && reviewState === numbers.TWO" [disabled]="createCommunityService.membersApiInProcess" [ngClass]="fcs.device_detail.is_mobile ? 'small' : 'medium'" class="btn-design filled position-relative ml-3  float-right" (click)="setMembers(true);selectionComplete()" >
        {{mls.languageText.community.key161}}
      </button>
      <button  [ngClass]="fcs.device_detail.is_mobile ? 'small' : 'medium'" class="btn-design outline position-relative float-right" (click)="cancelClicked()" >
        {{mls.languageText.community.key111}}
        </button>
  </div>
      
        <ng-content></ng-content>
      </div>
    </div>
  </div>
   
   <div *ngIf="cancelPopUp" class="modal fade" tabindex="-1" role="dialog" [config]="{ show: true, backdrop: 'static' }"
     bsModal #autoShownModal="bs-modal">
    <div class="custom-theme-modal modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body text-center">
         <p class="p-3 paragraph-bold font-weight-bold"> {{mls.languageText.community.key169}}</p>
          <div class="row">
            <div class="col-6">
              <button type="button" class="w-100 btn-design outline small" (click)="onCheckBoxModalHidden();clearAllClicked()">Discard Changes</button>
            </div>
            <div class="col-6">
              <button type="button" class="w-100 btn-design filled small" data-dismiss="modal" (click)="popUpClose()" >Okay Got it!</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> 
